import { useState, useEffect } from 'react';
import { listWorkspaces, deleteWorkspace } from '../api';

export default function MyWorkspacesPanel({ onLoad }) {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    try {
      const res = await listWorkspaces();
      setWorkspaces(res.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { fetch(); }, []);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete workspace "${name}"?`)) return;
    try {
      await deleteWorkspace(id);
      setWorkspaces((prev) => prev.filter((w) => w.id !== id));
    } catch {}
  };

  const handleLoad = (ws) => {
    onLoad(ws.papers, ws.name);
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-semibold text-[#171717]" style={{ letterSpacing: '-1.28px' }}>My Workspaces</h2>
        <p className="text-sm text-[#4d4d4d] mt-1">Load a saved collection of papers to continue your research.</p>
      </div>

      {loading ? (
        <p className="text-sm text-[#808080] text-center py-8">Loading...</p>
      ) : workspaces.length === 0 ? (
        <div className="text-center py-12 text-[#808080]">
          <p className="text-3xl mb-3">📁</p>
          <p className="text-sm font-medium">No saved workspaces yet.</p>
          <p className="text-xs mt-1 text-[#808080]">Search for papers, add them, then click "Save Workspace".</p>
        </div>
      ) : (
        <div className="space-y-2">
          {workspaces.map((ws) => (
            <div
              key={ws.id}
              className="bg-white rounded-lg p-4 flex items-center justify-between gap-3"
              style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px, rgba(0,0,0,0.04) 0px 2px 2px' }}
            >
              <div className="flex-1 min-w-0">
                <p className="font-medium text-[#171717] truncate text-sm" style={{ letterSpacing: '-0.32px' }}>{ws.name}</p>
                <p className="text-xs text-[#808080] mt-0.5">
                  {ws.paper_count} paper{ws.paper_count !== 1 ? 's' : ''} · {ws.updated_at}
                </p>
              </div>
              <div className="flex gap-2 flex-shrink-0">
                <button
                  onClick={() => handleLoad(ws)}
                  className="px-3 py-1.5 bg-[#171717] text-white text-xs font-medium rounded-md hover:bg-[#2e2e2e] transition-colors"
                >
                  Load
                </button>
                <button
                  onClick={() => handleDelete(ws.id, ws.name)}
                  className="px-3 py-1.5 text-xs font-medium rounded-md text-[#808080] hover:text-red-500 transition-colors"
                  style={{ boxShadow: 'rgba(0,0,0,0.08) 0px 0px 0px 1px' }}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
